import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
// import { Subscription } from 'rxjs';
// import { Router, NavigationExtras } from "@angular/router";
import { SharedService }  from "../../services/shared.service";
// import { EventEmitterService }  from "../../services/event-emitter.service";
import { DisbursementOccurrenceService }  from "../../services/disbursement-occurrence.service";
import { IDisbursementSession } from 'src/app/interfaces/disbursement-session';
import { IBrandProfile } from 'src/app/interfaces/brand-profile';
// import { IPaymentResponse } from 'src/app/interfaces/payment-response';
import { IDisbursementOccurrence } from '../../interfaces/disbursement-occurrence';
import { IPageContent } from '../../interfaces/page-content';
import { IFundingAccount } from 'src/app/interfaces/funding-account';
import { FundingAccountsService } from 'src/app/services/funding-accounts.service';
//import { IPaymentResponse } from 'src/app/interfaces/payment-response';

@Component({
  selector: 'app-disbursement-occurrences',
  templateUrl: './disbursement-occurrences.component.html',
  styleUrls: ['./disbursement-occurrences.component.css']
})
export class DisbursementOccurrencesComponent implements OnInit, OnDestroy {

  // private chosenFundingAccountSub!: Subscription;

  envRegion!: string;
  disbursementSession!: IDisbursementSession;
  brandProfile!: IBrandProfile;
  pageContent!: IPageContent;
  isLogoutVisible: boolean = true;

  // chosenFundingAccount?: any;
  dsbOccurrences: IDisbursementOccurrence[] | null = [];
  fundingAccounts: IFundingAccount[] = [];
  brandLogoImage!: any;

  public constructor(
    // private router: Router,
    private sharedService: SharedService,
    private disbursementOccurrenceService: DisbursementOccurrenceService,
    private fundingAccountsService: FundingAccountsService,
    // private eventEmitterService: EventEmitterService
    ) {
      // if (this.router.getCurrentNavigation()) {
      //   console.log(this.router.getCurrentNavigation()?.extras.state);
      //   this.chosenFundingAccount = this.router.getCurrentNavigation()?.extras.state;
      // }
    }

  ngOnInit() {
    // Get the current enviromental region
    this.envRegion = this.sharedService.getEnvRegion();

    // Get the current brand profile
    if (this.sharedService.getBrandProfile()) {
      this.brandProfile = this.sharedService.getBrandProfile();
    } else {
      // ??? what ???
    }

    // Make preparations for the page generic content
    this.pageContent = {
      headerTitle: this.sharedService.getCustomizedTitle('APP_TITLE') || '',
      headerSubtitle: this.sharedService.getCustomizedTitle('DSB_OCCURRENCES') || '',
      headerAvatar: 'negative-film-svgrepo-com.svg'
    }

    // Get the current disbursement session
    this.disbursementSession = this.sharedService.getDisbursementSession();
    console.log('occurrencies - ngOnInit - envRegion', this.envRegion);
    console.log('occurrencies - ngOnInit - disbursementSession', this.disbursementSession);

    this.getFundingAccounts();

    // Get disbursement occurrences

    // this.dsbOccurrences = this.sharedService.getDsbOccurrences();

    // if (!this.dsbOccurrences && this.disbursementSession && this.envRegion) {
    if (this.disbursementSession && this.envRegion) {
        this.disbursementOccurrenceService.fetchDisbursementOccurrences(this.envRegion, this.disbursementSession.sessionId)
      .subscribe({
        next: (response) => {
          if (response) {
            this.dsbOccurrences = response;
            this.dsbOccurrences.forEach(dsbOcc => {
              // console.log(dsbOcc.disbursementOccurrenceId,dsbOcc.status);
              dsbOcc.fundingAccountToken = "0";
              dsbOcc.disbursable = //!(dsbOcc.payments && dsbOcc.payments.length > 0) 
                 dsbOcc.status == "CREATED" || dsbOcc.status == "INVITED" 
                  || dsbOcc.status == "VIEWED" || dsbOcc.status == "ERROR";   // for now... but also need to check the payment status
            });
            this.sharedService.setDsbOccurrences(this.dsbOccurrences);
            this.disbursementOccurrenceService.markDisbursementOccurrencesAsViewed(this.envRegion, this.disbursementSession.sessionId)
              .subscribe({
                next: (value:any): void => {
                  console.log(value);
                },
                error: (err: any):void => {
                  console.log(err);
                },
                complete: (): void => {
                  console.log('markDisbursementOccurrencesAsViewed completed');
                }
              })
            // ??? Do i need to get and verify the response?
          }
        },
        error: (error) => {
        },
        complete: () => {
        }
      })
    } else if(this.dsbOccurrences) {
      this.sharedService.setDsbOccurrences(this.dsbOccurrences);
    }
  }

  getFundingAccounts() {
    let disbursementSession = this.sharedService.getDisbursementSession();
    let envRegion = this.sharedService.getEnvRegion();
    if (disbursementSession && envRegion) {
      this.fundingAccountsService.fetchFundingAccounts(envRegion, disbursementSession.sessionId)
      .subscribe(
        (response) => {
          let fundingAccountResponse = response;
          if (fundingAccountResponse) {
            this.fundingAccounts = fundingAccountResponse.tokenList;
            //this.fundingAccounts.push(DUMMY_FUNDING_ACCOUNT);
            this.fundingAccounts.sort((a, b) => (a.tokenid > b.tokenid) ? 1 : -1);
            ///// this.fundingAccounts.slice(0, 3);
            // Add a column for the checkbox
            this.fundingAccounts.map((obj) => {
              obj.checked = false;
              return obj;
            })

            // **** test ***
            //this.selectedFundingAccount = this.fundingAccounts[2];



            // // Figure out the message for the customer depending on whether there is already at least one funding account
            // if (this.fundingAccounts) {
            //   if (this.fundingAccounts.length > 0) {
            //     this.dsbMessage = this.sharedService.getCustomizedPrompt("FUNDING_ACCOUNTS_EXIST");
            //   }
            // }
          }
        }
      )
    }
  }

  disbursedFundsHandler (response: any /*IPaymentResponse*/) {
    //this.getDisbursementOccurrences();
  }

  ngOnDestroy() {
    // if (this.chosenFundingAccountSub) {
    //   this.chosenFundingAccountSub.unsubscribe();
    // }
    // "Persist" the list of occurrences in the cache
    this.sharedService.setDsbOccurrences(this.dsbOccurrences);
  }
}
